'use client';

import { trpc } from '@/lib/trpc';

/**
 * Reads the campaign-configured default vehicle make for the given event, used
 * to pre-select Make on the registration vehicle form. Returns null when unset.
 *
 * Shares the `getActiveCampaign` query cache with {@link useMarketingOptIns}, so
 * calling it from multiple registration steps issues no extra requests.
 */
export function useCampaignDefaultMake(eventId: string | null): string | null {
  const { data } = trpc.publicDonation.getActiveCampaign.useQuery(
    { eventId: eventId ?? undefined },
    { enabled: Boolean(eventId) },
  );
  return data?.defaultVehicleMake ?? null;
}
